import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { MessageEditor } from "@/components/MessageEditor";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";
const TPL = [["first", "Primeiro envio", "Quando se cria a angariação ou se envia a página pela primeira vez."],
  ["reminder", "1.º lembrete", "Quando falta alguma coisa ao cliente: 1.º lembrete automático e botão Lembrar."],
  ["reminder2", "2.º lembrete", "Mais direto: 2.º lembrete automático e botão Lembrar depois de já ter havido um lembrete."]];
const DAYS = [["client1", "1.º lembrete ao cliente"], ["client2", "2.º lembrete ao cliente"], ["staff", "Alerta ao consultor e à gestora"]];

function TemplateField({ k, label, hint, s, setT }) {
  const [code, setCode] = useState(false);
  const sample = (k === "first" && s.sample_first) || s.sample || {};
  return (
    <div data-testid={`tpl-block-${k}`}>
      <div className="flex items-center justify-between gap-3"><Label>{label}</Label>
        <div className="flex gap-4 text-xs text-slate-500">
          {s.templates[k] !== s.defaults[k] && <button type="button" onClick={() => setT(k, s.defaults[k])} className="hover:underline" data-testid={`tpl-reset-${k}`}>Repor texto original</button>}
          <button type="button" onClick={() => setCode(!code)} className="hover:underline" data-testid={`tpl-code-toggle-${k}`}>{code ? "Esconder código" : "Ver código"}</button>
        </div>
      </div>
      <p className="text-xs text-slate-500 mt-0.5 mb-2">{hint} Escreva diretamente na mensagem; as partes a azul são automáticas e mudam para cada cliente.</p>
      <div className={code ? "grid lg:grid-cols-2 gap-5" : ""}>
        <MessageEditor value={s.templates[k]} sample={sample} fields={s.placeholders_by?.[k] || s.placeholders} onChange={(v) => setT(k, v)} testid={`tpl-editor-${k}`} />
        {code && <Textarea rows={13} value={s.templates[k]} onChange={(e) => setT(k, e.target.value)} className="text-sm font-mono" data-testid={`tpl-${k}`} />}
      </div>
    </div>
  );
}

export function MensagensDefinicoes() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/agency/messages").then(({ data }) => setS(data)); }, []);
  if (!s) return <div className={card}>A carregar…</div>;
  const save = async () => {
    try { const { data } = await api.put("/agency/messages", { templates: s.templates, days: s.days }); setS(data); toast.success("Mensagens e lembretes guardados"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const setT = (k, v) => setS({ ...s, templates: { ...s.templates, [k]: v } });
  return (
    <div className="space-y-6" data-testid="messages-settings">
      <div className={card}>
        <h3 className="font-heading text-lg navy-text">Dias dos lembretes automáticos</h3>
        <p className="text-sm text-slate-500 mb-5">Contados desde o envio do link. Só em dias úteis, das 9h às 20h.</p>
        <div className="grid sm:grid-cols-3 gap-4 max-w-2xl">
          {DAYS.map(([k, label]) => (
            <div key={k}><Label>{label}</Label>
              <div className="flex items-center gap-2 mt-1.5">
                <Input type="number" min={1} max={60} value={s.days[k]} onChange={(e) => setS({ ...s, days: { ...s.days, [k]: e.target.value } })} className="w-20" data-testid={`days-${k}`} />
                <span className="text-sm text-slate-500">dias</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={card}>
        <h3 className="font-heading text-lg navy-text">Mensagens ao cliente</h3>
        <p className="text-sm text-slate-500 mb-5">O mesmo texto vai por WhatsApp e por email (no email, o link aparece como o botão «Abrir a minha página»).</p>
        <div className="space-y-8">{TPL.map(([k, label, hint]) => <TemplateField key={k} k={k} label={label} hint={hint} s={s} setT={setT} />)}</div>
      </div>
      <button onClick={save} className="navy-bg text-white px-5 py-2.5 rounded-lg font-semibold hover:brightness-110 transition-[filter]" data-testid="messages-save">Guardar mensagens e lembretes</button>
    </div>
  );
}
